import React from 'react'
import { isPromocodeWithComment, isPromocodeWithLegalText, Promocode } from 'modules/domain/promocode/types'
import { TextAreaWithTags } from '@agro-club/frontend-shared'

export type PromocodeListProps = {
  promocodes: Promocode[]
  onRemove: (id: string) => void
  onCommentChange: (code: string, comment: string) => void
  selectedPromocode?: string
  onSelectPromocode: (code: string) => void
}

export const PromocodeList: React.VFC<PromocodeListProps> = ({
  promocodes,
  onRemove,
  onCommentChange,
  selectedPromocode: selectedPromocodeFromProps,
  onSelectPromocode,
}) => {
  const handleRemove = (id: string) => {
    onRemove(id)
    if (id === selectedPromocode) {
      onSelectPromocode('')
    }
  }

  const items = promocodes.map((item) => {
    let placeholder
    let value
    let readOnly = false
    let editable: boolean | undefined = false
    let selectable: boolean | undefined = false

    if (isPromocodeWithComment(item)) {
      placeholder = item.params.prompt || undefined
      editable = !!item.params.prompt
      value = item.comment || undefined
      selectable = true
    }

    if (isPromocodeWithLegalText(item)) {
      value = item.params.legal_text || undefined
      readOnly = true
      selectable = true
    }
    return {
      id: item.code,
      title: item.code,
      placeholder,
      editable,
      value,
      selectable,
      readonly: readOnly,
    }
  })

  // select first editable, readonly or selected
  const selectedPromocode =
    selectedPromocodeFromProps ||
    promocodes.find((item) => {
      if (isPromocodeWithComment(item)) {
        return !!item.params.prompt
      }
      if (isPromocodeWithLegalText(item)) {
        return !!item.params.legal_text
      }
    })?.code

  return (
    <div data-test-id={'promocode-textarea'}>
      <TextAreaWithTags
        items={items}
        selected={selectedPromocode}
        onTextChange={onCommentChange}
        onSelectionChange={onSelectPromocode}
        onRemove={handleRemove}
      />
    </div>
  )
}
